import { apiClient } from '../api/apiClient';

export const marketplaceService = {
    getListings(params) {
        return apiClient.get(`marketplace/listings?${params.toString()}`);
    },

    getListing(listingId) {
        return apiClient.get(`marketplace/listings/${listingId}`);
    },

    getSharedListing(token) {
        return apiClient.get(`marketplace/shared/${encodeURIComponent(token)}`);
    },

    resolveSharedListing(token) {
        return apiClient.get(`marketplace/shared/${encodeURIComponent(token)}/resolve`);
    },

    getClubListings(clubId, take = 8) {
        return apiClient.get(`marketplace/club/${clubId}/listings?take=${take}`);
    },

    toggleFavourite(listingId) {
        return apiClient.post(`marketplace/listings/${listingId}/favourite`);
    },

    getCategories() {
        return apiClient.get('marketplace/categories');
    },

    createOffer(payload) {
        return apiClient.post('marketplace/offers', { json: payload });
    },

    createListing(payload) {
        return apiClient.post('marketplace/listings', { json: payload });
    },

    getMyListings() {
        return apiClient.get('marketplace/my-listings');
    },

    getReceivedOffers() {
        return apiClient.get('marketplace/offers/received');
    },

    getTransactions() {
        return apiClient.get('marketplace/transactions');
    },

    deleteListing(listingId) {
        return apiClient.del(`marketplace/listings/${listingId}`);
    },

    getEquipmentCategories() {
        return apiClient.get('equipment/categories');
    },

    getEquipmentBrands(categoryId) {
        return apiClient.get(`equipment/brands?categoryId=${categoryId}`);
    }
};
